// Web-only strings for the account settings page (src/ui/features/settings). The own-profile half
// uses the Apple `profile.*` keys; these are the page chrome and the Mattermost-webapp settings the
// apps never edited (notifications, display, security). Both languages, always.
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.settings.title': 'Configuración',
    'web.settings.myProfile': 'Mi perfil',
    'web.settings.openSettings': 'Configuración',
    'web.settings.section.profile': 'Mi perfil',
    'web.settings.section.status': 'Estado',
    'web.settings.section.notifications': 'Notificaciones',
    'web.settings.section.appearance': 'Apariencia',
    'web.settings.section.display': 'Pantalla',
    'web.settings.section.language': 'Idioma',
    'web.settings.section.security': 'Seguridad',
    'web.settings.section.blocked': 'Usuarios bloqueados',
    'web.settings.section.channelTypes': 'Tipos de canal',
    'web.settings.backToSections': 'Volver a Configuración',
    'web.settings.saving': 'Guardando…',
    'web.settings.saved': 'Guardado',
    'web.settings.saveFailed': 'No se pudo guardar.',
    'web.settings.loadFailed': 'No se pudo cargar tu cuenta.',
    'web.settings.localOnly': 'Se guarda en este navegador.',
    'web.settings.serverWide': 'Se aplica en todos tus dispositivos.',
    // Profile
    'web.settings.photo.change': 'Cambiar foto',
    'web.settings.photo.remove': 'Quitar foto',
    'web.settings.photo.uploading': 'Subiendo foto…',
    'web.settings.photo.failed': 'No se pudo cambiar la foto.',
    'web.settings.photo.notImage': 'Ese archivo no es una imagen.',
    'web.settings.profile.details': 'Datos',
    'web.settings.profile.account': 'Cuenta',
    'web.settings.profile.unchanged': 'Sin cambios',
    // Status
    'web.settings.status.dndFor': '¿Por cuánto tiempo?',
    'web.settings.dnd.dontClear': 'No borrar',
    'web.settings.dnd.thirtyMinutes': '30 minutos',
    'web.settings.dnd.oneHour': '1 hora',
    'web.settings.dnd.twoHours': '2 horas',
    'web.settings.dnd.tomorrow': 'Mañana a las 9:00',
    'web.settings.customStatus.recent': 'Recientes',
    'web.settings.customStatus.forget': 'Quitar de recientes',
    'web.settings.customStatus.pickEmoji': 'Elegir emoji',
    'web.settings.customStatus.edit': 'Cambiar',
    'web.settings.ooo.editTitle': 'Mensaje de fuera de la oficina',
    // Notifications
    'web.settings.notif.desktop': 'En este navegador',
    'web.settings.notif.desktopHint': 'Avisos mientras Satori Chat está abierto en una pestaña.',
    'web.settings.notif.push': 'En el celular',
    'web.settings.notif.pushHint': 'Lo que llega a la app del celular.',
    'web.settings.notif.level.all': 'Todo',
    'web.settings.notif.level.mention': 'Menciones y mensajes directos',
    'web.settings.notif.level.none': 'Nada',
    'web.settings.notif.threads': 'Respuestas en hilos que sigo',
    'web.settings.notif.threadsHint': 'Avísame de cada respuesta en los hilos donde participo.',
    'web.settings.notif.pushStatus': 'Enviar al celular cuando estoy',
    'web.settings.notif.pushStatus.online': 'En línea, ausente o desconectado',
    'web.settings.notif.pushStatus.away': 'Ausente o desconectado',
    'web.settings.notif.pushStatus.offline': 'Desconectado',
    'web.settings.notif.keywords': 'Palabras que te notifican',
    'web.settings.notif.firstName': 'Tu nombre «%@»',
    'web.settings.notif.firstNameHint': 'Distingue mayúsculas y minúsculas.',
    'web.settings.notif.channelWide': '@channel, @all y @here',
    'web.settings.notif.channelWideHint': 'Menciones a todo el canal.',
    'web.settings.notif.customWords': 'Otras palabras',
    'web.settings.notif.customWordsHint': 'Sin distinguir mayúsculas. Escribe una palabra y pulsa Enter.',
    'web.settings.notif.addWord': 'Añadir palabra',
    'web.settings.notif.removeWord': 'Quitar «%@»',
    'web.settings.notif.replies': 'Respuestas a hilos',
    'web.settings.notif.replies.any': 'De cualquier hilo en el que participé',
    'web.settings.notif.replies.root': 'Solo de hilos que yo empecé',
    'web.settings.notif.replies.never': 'Solo si me mencionan',
    'web.settings.notif.email': 'Correo electrónico',
    'web.settings.notif.emailToggle': 'Enviarme correos de lo que me perdí',
    'web.settings.notif.emailInterval': 'Frecuencia',
    'web.settings.notif.email.30': 'De inmediato',
    'web.settings.notif.email.900': 'Cada 15 minutos',
    'web.settings.notif.email.3600': 'Cada hora',
    // Appearance
    'web.settings.theme': 'Tema',
    // Display
    'web.settings.display.threads': 'Hilos contraídos',
    'web.settings.display.threadsHint': 'Las respuestas viven en su hilo y en «Hilos», no en la conversación.',
    'web.settings.display.threadsLocked': 'Lo decide el servidor para todos.',
    'web.settings.display.clock': 'Reloj',
    'web.settings.display.clock12': '12 horas (3:45 p.m.)',
    'web.settings.display.clock24': '24 horas (15:45)',
    'web.settings.display.names': 'Cómo se muestran los nombres',
    'web.settings.display.namesLocked': 'El servidor fija cómo se muestran los nombres.',
    'web.settings.display.name.full_name': 'Nombre y apellido',
    'web.settings.display.name.nickname_full_name': 'Apodo si lo tiene, si no nombre y apellido',
    'web.settings.display.name.username': 'Nombre de usuario',
    'web.settings.display.linkPreviews': 'Vista previa de enlaces',
    'web.settings.display.linkPreviewsHint': 'Muestra el título y la imagen de los enlaces en los mensajes.',
    // Language
    'web.settings.language.live': 'El cambio se aplica al instante.',
    // Security
    'web.settings.security.password': 'Contraseña',
    'web.settings.security.current': 'Contraseña actual',
    'web.settings.security.new': 'Contraseña nueva',
    'web.settings.security.confirm': 'Repite la contraseña nueva',
    'web.settings.security.change': 'Cambiar contraseña',
    'web.settings.security.changed': 'Contraseña cambiada.',
    'web.settings.security.wrongCurrent': 'La contraseña actual no es correcta.',
    'web.settings.security.mismatch': 'Las dos contraseñas nuevas no coinciden.',
    'web.settings.security.same': 'La contraseña nueva es igual a la actual.',
    'web.settings.security.missing': 'Llena los tres campos.',
    'web.settings.security.rejected': 'El servidor no aceptó la contraseña nueva.',
    'web.settings.security.network': 'Sin conexión con el servidor. Inténtalo de nuevo.',
    'web.settings.security.sso': 'Tu cuenta entra con %@; la contraseña se cambia allí.',
    'web.settings.security.sessions': 'Sesiones activas',
    'web.settings.security.sessionsHint': 'Dónde está abierta tu cuenta. Cerrar una sesión la obliga a entrar de nuevo.',
    'web.settings.security.thisSession': 'Esta sesión',
    'web.settings.security.lastActive': 'Activa %@',
    'web.settings.security.revoke': 'Cerrar sesión',
    'web.settings.security.revokeConfirm': '¿Cerrar?',
    'web.settings.security.revokeOthers': 'Cerrar las demás sesiones',
    'web.settings.security.revokeOthersConfirm': '¿Cerrar todas las demás?',
    'web.settings.security.revokeFailed': 'No se pudo cerrar la sesión.',
    'web.settings.security.sessionsFailed': 'No se pudieron cargar las sesiones.',
    'web.settings.security.noOthers': 'No hay otras sesiones abiertas.',
    'web.settings.security.kind.mobile': 'App del celular',
    'web.settings.security.kind.desktop': 'App de escritorio',
    'web.settings.security.kind.browser': 'Navegador',
    'web.settings.security.kind.other': 'Sesión',
    'web.settings.security.unrecognized': 'App no reconocida',
    'web.settings.version': 'Satori Chat Web %@',
  },
  en: {
    'web.settings.title': 'Settings',
    'web.settings.myProfile': 'My profile',
    'web.settings.openSettings': 'Settings',
    'web.settings.section.profile': 'My profile',
    'web.settings.section.status': 'Status',
    'web.settings.section.notifications': 'Notifications',
    'web.settings.section.appearance': 'Appearance',
    'web.settings.section.display': 'Display',
    'web.settings.section.language': 'Language',
    'web.settings.section.security': 'Security',
    'web.settings.section.blocked': 'Blocked users',
    'web.settings.section.channelTypes': 'Channel types',
    'web.settings.backToSections': 'Back to Settings',
    'web.settings.saving': 'Saving…',
    'web.settings.saved': 'Saved',
    'web.settings.saveFailed': 'Could not save.',
    'web.settings.loadFailed': 'Could not load your account.',
    'web.settings.localOnly': 'Kept in this browser.',
    'web.settings.serverWide': 'Applies on all your devices.',
    'web.settings.photo.change': 'Change photo',
    'web.settings.photo.remove': 'Remove photo',
    'web.settings.photo.uploading': 'Uploading photo…',
    'web.settings.photo.failed': 'Could not change the photo.',
    'web.settings.photo.notImage': 'That file is not an image.',
    'web.settings.profile.details': 'Details',
    'web.settings.profile.account': 'Account',
    'web.settings.profile.unchanged': 'No changes',
    'web.settings.status.dndFor': 'For how long?',
    'web.settings.dnd.dontClear': 'Don’t clear',
    'web.settings.dnd.thirtyMinutes': '30 minutes',
    'web.settings.dnd.oneHour': '1 hour',
    'web.settings.dnd.twoHours': '2 hours',
    'web.settings.dnd.tomorrow': 'Tomorrow at 9:00',
    'web.settings.customStatus.recent': 'Recent',
    'web.settings.customStatus.forget': 'Remove from recent',
    'web.settings.customStatus.pickEmoji': 'Choose emoji',
    'web.settings.customStatus.edit': 'Change',
    'web.settings.ooo.editTitle': 'Out-of-office message',
    'web.settings.notif.desktop': 'In this browser',
    'web.settings.notif.desktopHint': 'Alerts while Satori Chat is open in a tab.',
    'web.settings.notif.push': 'On your phone',
    'web.settings.notif.pushHint': 'What reaches the phone app.',
    'web.settings.notif.level.all': 'Everything',
    'web.settings.notif.level.mention': 'Mentions and direct messages',
    'web.settings.notif.level.none': 'Nothing',
    'web.settings.notif.threads': 'Replies in threads I follow',
    'web.settings.notif.threadsHint': 'Tell me about every reply in threads I take part in.',
    'web.settings.notif.pushStatus': 'Send to my phone when I am',
    'web.settings.notif.pushStatus.online': 'Online, away or offline',
    'web.settings.notif.pushStatus.away': 'Away or offline',
    'web.settings.notif.pushStatus.offline': 'Offline',
    'web.settings.notif.keywords': 'Words that notify you',
    'web.settings.notif.firstName': 'Your first name “%@”',
    'web.settings.notif.firstNameHint': 'Case-sensitive.',
    'web.settings.notif.channelWide': '@channel, @all and @here',
    'web.settings.notif.channelWideHint': 'Mentions of the whole channel.',
    'web.settings.notif.customWords': 'Other words',
    'web.settings.notif.customWordsHint': 'Not case-sensitive. Type a word and press Enter.',
    'web.settings.notif.addWord': 'Add word',
    'web.settings.notif.removeWord': 'Remove “%@”',
    'web.settings.notif.replies': 'Thread replies',
    'web.settings.notif.replies.any': 'From any thread I took part in',
    'web.settings.notif.replies.root': 'Only from threads I started',
    'web.settings.notif.replies.never': 'Only when I am mentioned',
    'web.settings.notif.email': 'Email',
    'web.settings.notif.emailToggle': 'Email me what I missed',
    'web.settings.notif.emailInterval': 'How often',
    'web.settings.notif.email.30': 'Immediately',
    'web.settings.notif.email.900': 'Every 15 minutes',
    'web.settings.notif.email.3600': 'Every hour',
    'web.settings.theme': 'Theme',
    'web.settings.display.threads': 'Collapsed reply threads',
    'web.settings.display.threadsHint': 'Replies live in their thread and in “Threads”, not in the conversation.',
    'web.settings.display.threadsLocked': 'Set by the server for everyone.',
    'web.settings.display.clock': 'Clock',
    'web.settings.display.clock12': '12-hour (3:45 PM)',
    'web.settings.display.clock24': '24-hour (15:45)',
    'web.settings.display.names': 'How names are shown',
    'web.settings.display.namesLocked': 'The server sets how names are shown.',
    'web.settings.display.name.full_name': 'First and last name',
    'web.settings.display.name.nickname_full_name': 'Nickname if set, otherwise first and last name',
    'web.settings.display.name.username': 'Username',
    'web.settings.display.linkPreviews': 'Link previews',
    'web.settings.display.linkPreviewsHint': 'Show the title and image of links in messages.',
    'web.settings.language.live': 'The change applies right away.',
    'web.settings.security.password': 'Password',
    'web.settings.security.current': 'Current password',
    'web.settings.security.new': 'New password',
    'web.settings.security.confirm': 'Repeat the new password',
    'web.settings.security.change': 'Change password',
    'web.settings.security.changed': 'Password changed.',
    'web.settings.security.wrongCurrent': 'The current password is not correct.',
    'web.settings.security.mismatch': 'The two new passwords do not match.',
    'web.settings.security.same': 'The new password is the same as the current one.',
    'web.settings.security.missing': 'Fill in all three fields.',
    'web.settings.security.rejected': 'The server did not accept the new password.',
    'web.settings.security.network': 'No connection to the server. Try again.',
    'web.settings.security.sso': 'Your account signs in with %@; change the password there.',
    'web.settings.security.sessions': 'Active sessions',
    'web.settings.security.sessionsHint': 'Where your account is signed in. Ending a session makes it sign in again.',
    'web.settings.security.thisSession': 'This session',
    'web.settings.security.lastActive': 'Active %@',
    'web.settings.security.revoke': 'Sign out',
    'web.settings.security.revokeConfirm': 'Sign out?',
    'web.settings.security.revokeOthers': 'Sign out all other sessions',
    'web.settings.security.revokeOthersConfirm': 'Sign out all others?',
    'web.settings.security.revokeFailed': 'Could not end the session.',
    'web.settings.security.sessionsFailed': 'Could not load the sessions.',
    'web.settings.security.noOthers': 'No other sessions are open.',
    'web.settings.security.kind.mobile': 'Phone app',
    'web.settings.security.kind.desktop': 'Desktop app',
    'web.settings.security.kind.browser': 'Browser',
    'web.settings.security.kind.other': 'Session',
    'web.settings.security.unrecognized': 'Unrecognized app',
    'web.settings.version': 'Satori Chat Web %@',
  },
};
